// extracted by mini-css-extract-plugin
export var layoutContainer = "_7a-0";
export var layoutContainerNoRounding = "_7a-6";
export var layoutContainerOpen = "_7a-5";
export var layoutContainerResizing = "_7a-1";
export var mainContent = "_7a-2";
export var resizeDivider = "_7a-3";
export var slidePanel = "_7a-4";